<template>
  <div class="class-report-detail">
    <header>
      <!-- 面包屑 -->
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <span class="go-back" @click="goBack">备课中心</span>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <span>报告详情</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <!-- 标题 -->
      <div class="header-title">
        <card-header>{{ evaluateName }}</card-header>
        <div class="header-title__right">
          <span>{{ currentClassName }}</span>
          <el-popover v-model="visibleClassList" v-if="allClassList.length > 1">
            <div style="text-align: center">
              <p
                @click="selectClass(item)"
                v-for="(item, index) in allClassList"
                :key="index"
                style="
                  line-height: 30px;
                  cursor: pointer;
                  border: 1px solid;
                  border-radius: 4px;
                  margin-bottom: 2px;
                "
                :class="
                  currentClassName === item.class_name
                    ? 'class-prepare-page__checked-class'
                    : ''
                "
              >
                {{ item.class_name }}
              </p>
            </div>
            <span class="choose-class" slot="reference">切换班级</span>
          </el-popover>
        </div>
      </div>
      <!-- 副标题 -->
      <div class="header-subhead">
        <p>总知识点视频数：{{ tagCodeNum }}个</p>
        <p class="header-subhead__right">
          预习班级：<span v-for="(cName, index) in allClassList" :key="index">{{
            cName.class_name
          }}</span>
        </p>
      </div>
    </header>
    <section>
      <h3 class="overview-title">预习概览</h3>
      <ul class="overview-content">
        <li class="overview-content__finished">
          <i />
          <div class="finished-item item">
            <p>全部预习完成人数</p>
            <p class="finished-item__bottom">
              <span class="finished-number">{{ finishedNum }}</span> /
              <span>{{ totalStu }}</span>
            </p>
          </div>
        </li>
        <li class="overview-content__average">
          <i />
          <div class="average-item item">
            <p>平均预习知识点数</p>
            <p class="average-item__bottom">
              <span class="average-number">{{ avgComplementNum }}</span
              >个
            </p>
          </div>
        </li>
        <li class="overview-content__unfinished">
          <i />
          <div class="unfinished-item item">
            <p>未预习人数</p>
            <p class="unfinished-item__bottom">
              <el-popover
                placement="bottom"
                width="280"
                trigger="hover"
                ref="lookDetail"
              >
                <span v-for="(stu, index) in unfinishedList" :key="index">{{
                  (stu = index == unfinishedList.length - 1 ? stu : `${stu}、`)
                }}</span>
              </el-popover>
              <span class="look-detail" v-popover:lookDetail>查看详情</span
              ><span class="unfinished-number">{{ unfinishedList.length }}</span
              >个
            </p>
          </div>
        </li>
      </ul>
    </section>
    <footer>
      <h3 class="overview-title">预习明细</h3>
      <div class="subhead">
        <p class="subhead__annotation">
          * 知识点视频观看时长超过50%认为已观看该视频
        </p>
        <div class="download">
          <p class="finished-prepare">已完成预习</p>
          <p class="unfinished-prepare">未完成预习</p>
          <el-button
            type="primary"
            :disabled="!tableData"
            @click="exportClassReport"
          >
            <span class="download-icon">下载详细数据</span>
          </el-button>
        </div>
      </div>
      <!-- excel表格 -->
      <el-table :data="tableData" border style="width: 100%">
        <!-- 学生名称 -->
        <el-table-column label="学生名称" fixed="left" width="120">
          <template slot-scope="scope">
            <span
              >{{ scope.row.student_name }} ({{ scope.row.complete_num }}/{{
                 tagCodeNum
              }})</span
            >
          </template>
        </el-table-column>
        <!-- 知识点名称 -->
        <el-table-column
          v-for="(item,index) in tableName"
          :key="index"
          :label="item"
          :prop="String(item.tag_code)"
          width="240"
          align="center"
        >
          <template slot="header" slot-scope="scope">
            <span @click="onDetailClick(scope.column.label)"
               class="header-cursor"
              >{{ scope.column.label.tag_name }}({{
                scope.column.label.complete_stu
              }}/{{totalStu}})</span
            >
          </template>
          <template slot-scope="scope">
            <img
              :style="
                (width = scope.row[item.tag_code] == 1 ? '22px' : '16px')
              "
              :src="
                scope.row[item.tag_code] == 1
                  ? require('../../../assets/img/prepared.png')
                  : require('../../../assets/img/unprepare.png')
              "
            />
          </template>
        </el-table-column>
      </el-table>
    </footer>
    <LoDialog
      :code="currentTagCode"
      :data="tagCodeList"
      :visible.sync="visible"
      :subjectId="subjectId"
      v-if="visible"
    />
  </div>
</template>

<script>
import { getClassListByBatchId, getPreviewReport } from '@/api/pt';
import CardHeader from '@/components/card-header.vue';
import LoDialog from './components/lo-dialog.vue';

export default {
  name: 'ClassReportDetail',
  components: {
    CardHeader,
    LoDialog,
  },
  data() {
    const {
      batchId, evaluateId, classId, className, subjectId,
    } = this.$route.query;
    const userInfo = JSON.parse(localStorage.getItem('CRM_USER_INFO')) || {};
    return {
      schoolId: userInfo.campusId,
      batchId,
      subjectId,
      evaluateName: '',
      currentEvaluateId: evaluateId, // 当前预习ID
      currentClassId: classId, // 当前班级ID
      currentClassName: className, // 当前班级名称
      tagCodeNum: 0, // 知识点数
      tagCodeList: [], // 知识点列表
      totalStu: 0, // 预习总人数
      finishedNum: 0, // 预习完成人数
      unfinishedList: [], // 未完成预习的人
      currentTagCode: '',
      visibleClassList: false,
      visible: false,
      avgComplementNum: 0, // 平均知识点预习数
      allClassList: [], // 可切换班级列表
      tableName: [],
      tableData: [],
      defaultList: {
        class_list: [],
        evaluate_name: '0902化学预习测试',
        class_id: '630126681897656320',
        class_name: '六年级1班',
        course_id: 10003427,
        lesson_id: 1660,
        tag_code_num: 1,
        total_stu: 8,
        avg_complete_num: 0,
        complete_stu: 0,
        incomplete_list: [
          '于毅',
          '于小胖',
          '于叮叮',
          '于满',
          '于梦令',
          '于波',
          '于赞',
          '于数',
        ],
        tag_code_list: [
          {
            tag_code: 'hx_cz_ll_lhbh_01',
            tag_name: '物理变化和化学变化',
            complete_stu: 0,
          },
        ],
        stu_list: [
          {
            account_id: 8889295193168995,
            student_name: '于毅',
            complete_num: 0,
            hx_cz_ll_lhbh_01: 1,
          },
          {
            account_id: 8889295193169444,
            student_name: '于小胖',
            complete_num: 0,
            hx_cz_ll_lhbh_01: 1,

          },
          {
            account_id: 8889295193169999,
            student_name: '于叮叮',
            complete_num: 0,
            hx_cz_ll_lhbh_01: 1,

          },
          {
            account_id: 8889295193204526,
            student_name: '于满',
            complete_num: 0,
            hx_cz_ll_lhbh_01: 0,

          },
          {
            account_id: 8889295193206030,
            student_name: '于梦令',
            complete_num: 0,
            hx_cz_ll_lhbh_01: 0,

          },
          {
            account_id: 8889295193207097,
            student_name: '于波',
            complete_num: 0,
            hx_cz_ll_lhbh_01: 0,

          },
          {
            account_id: 8889295193209440,
            student_name: '于赞',
            complete_num: 0,
            hx_cz_ll_lhbh_01: 0,

          },
          {
            account_id: 8889295193217519,
            student_name: '于数',
            complete_num: 0,
            hx_cz_ll_lhbh_01: 0,

          },
        ],
      },
    };
  },
  methods: {
    // 获取当前老师的班级列表
    async getClassListByBatchId() {
      await getClassListByBatchId({
        school_id: this.schoolId,
        batch_id: this.batchId,
      }).then((res) => {
        if (res.code === 200) {
          this.allClassList = res.data;
        }
      });
    },
    // 切换班级
    selectClass(item) {
      this.visibleClassList = false;
      this.currentEvaluateId = item.evaluate_id;
      this.currentClassId = item.class_id;
      this.currentClassName = item.class_name;
      this.getPreviewReport();
    },
    // 获取当前班级预习报告详情
    async getPreviewReport() {
      await getPreviewReport({
        batch_id: this.batchId,
        school_id: this.schoolId,
        class_id: this.currentClassId,
        evaluate_id: this.currentEvaluateId,
      }).then((res) => {
        /* eslint-disable */
        if (res.code === 200) {
          const {
            tag_code_num, total_stu, complete_stu, incomplete_list, tag_code_list, stu_list, evaluate_name, avg_complete_num,
          } = res.data;
          this.tableData = stu_list;
          this.tableName = tag_code_list;
          this.tagCodeNum = tag_code_num;
          this.totalStu = total_stu;
          this.finishedNum = complete_stu;
          this.unfinishedList = incomplete_list;
          this.evaluateName = evaluate_name;
          this.avgComplementNum = avg_complete_num;
        }
        this.tableName.forEach(item => {
          this.tagCodeList.push({ knowledge_name: item.tag_name, knowledge_code: item.tag_code });
        });
      });
    },
    // 点击参看视频讲义
    onDetailClick(row) {
      this.visible = true;
      console.log(row)
      this.currentTagCode = row.tag_code;
    },
    // 导出预习excel表格
    exportClassReport() {
      const isProduction = !window.location.host.includes('dev');
      const address = isProduction
        ? 'https://jzjx.classba.cn'
        : 'https://jzjx.test.classba.cn';
      const url = `${address}/pt/api/report/exportClassReport?school_id=${this.schoolId}&class_id=${this.currentClassId}&evaluate_id=${this.currentEvaluateId}&batch_id=${this.batchId}`;
      window.location.href = url;
    },
    goBack() {
      this.$router.go(-1);
    },
    default() {
        const {
            tag_code_num, total_stu, complete_stu, incomplete_list, tag_code_list, stu_list, evaluate_name, avg_complete_num,
          } = this.defaultList;
         this.tableData = stu_list;
          this.tableName = tag_code_list;
          this.tagCodeNum = tag_code_num;
          this.totalStu = total_stu;
          this.finishedNum = complete_stu;
          this.unfinishedList = incomplete_list;
          this.evaluateName = evaluate_name;
          this.avgComplementNum = avg_complete_num;
        this.tableData.forEach(item => {
          this.tagCodeList.push({ knowledge_name: item.tag_name, knowledge_code: item.tag_code });
        });
    }
  },
  created() {
    this.getClassListByBatchId();
    this.getPreviewReport();
    // this.default()
  },
  destroyed() {
    this.visible = false;
  },
};
</script>

<style lang="scss" scoped>
.class-report-detail {
  // padding: 20px 20px 68px;
  // background: #fff;
  min-height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  position: relative;
  header {
    padding: 20px 20px 68px;
    background: #fff;
    font-size: 14px;
    color: rgba(48, 49, 51, 0.6);
    padding-bottom: 24px;
    border-bottom: 6px solid #f0f2f5;
    .go-back {
      color: #1989fa;
      cursor: pointer;
    }
    .header-title {
      margin-top: 19px;
      font-size: 18px;
      color: #000000;
      display: flex;
      justify-content: space-between;
      &__right {
        font-size: 16px;
        color: #000000;
        .choose-class {
          margin-left: 16px;
          color: rgba(25, 137, 250, 1);
          background: url("../images/choose_class.png") no-repeat left center;
          background-size: 16px 16px;
          padding-left: 18px;
          cursor: pointer;
        }
      }
    }
    .header-subhead {
      margin-top: 20px;
      display: flex;
      font-size: 15px;
      &__right {
        margin-left: 30px;
        span {
          position: relative;
          padding-right: 10px;
          &::after {
            content: "、";
            position: absolute;
          }
          &:last-of-type::after {
            content: "";
          }
        }
      }
    }
  }
  .overview-title {
    font-size: 17px;
    color: rgba(0, 0, 0, 0.8);
    background: url("../images/class_bg.png") no-repeat left;
    background-size: contain;
    padding-left: 11px;
    margin-bottom: 22px;
  }
  section {
    padding: 20px;
    background: #fff;
    .overview-content {
      display: flex;
      justify-content: space-evenly;
      li {
        flex: 1;
        height: 1.46rem;
        background: #f0f2f8;
        border-radius: 12px;
        margin-right: 20px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        font-size: 16px;
        font-weight: 530;
        color: #808baa;
        .item {
          height: 0.9rem;
          padding: 0.06rem;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: flex-end;
        }
      }
      &__finished {
        i {
          display: block;
          width: 0.9rem;
          height: 0.9rem;
          background: url("../images/report_detail_all.png") no-repeat;
          background-size: cover;
        }
        .finished-item {
          &__bottom {
            color: rgba(88, 96, 119, 1);
            font-size: 0.36rem;
            .finished-number {
              color: rgba(2, 195, 135, 1);
            }
          }
        }
      }
      &__average {
        i {
          display: block;
          width: 0.9rem;
          height: 0.9rem;
          background: url("../images/report_detail_average.png") no-repeat;
          background-size: cover;
        }
        .average-item {
          &__bottom {
            color: rgba(88, 96, 119, 1);
            font-size: 0.24rem;
            .average-number {
              color: rgba(25, 137, 250, 1);
              font-size: 0.36rem;
              margin-right: 7px;
            }
          }
        }
      }
      &__unfinished {
        margin-right: 0px !important;
        i {
          display: block;
          width: 0.9rem;
          height: 0.9rem;
          background: url("../images/report_detail_unfinished.png") no-repeat;
          background-size: cover;
        }
        .unfinished-item {
          &__bottom {
            font-size: 0.24rem;
            color: rgba(88, 96, 119, 1);
            .look-detail {
              font-size: 0.14rem;
              color: #1989fa;
              text-decoration: underline;
              margin-right: 0.17rem;
              cursor: pointer;
            }
            .unfinished-number {
              color: rgba(245, 108, 108, 1);
              font-size: 0.36rem;
              margin-right: 7px;
            }
          }
        }
      }
    }
  }
  footer {
    padding: 20px 20px 68px;
    background: #fff;
    .subhead {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 27px;
      &__annotation {
        box-sizing: border-box;
        padding-bottom: 5px;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.6);
      }
      .download {
        display: flex;
        align-items: center;
        font-size: 14px;
        .finished-prepare {
          background: url("../images/finished_prepare.png") no-repeat left
            center;
          padding-left: 42px;
          background-size: 30px 24px;
          margin-right: 19px;
          height: 28px;
          line-height: 28px;
          color: #02c387;
        }
        .unfinished-prepare {
          background: url("../images/unfinished_prepare.png") no-repeat left
            center;
          background-size: 30px 24px;
          padding-left: 42px;
          margin-right: 24px;
          height: 28px;
          line-height: 28px;
          color: #f56c6c;
        }
        .download-icon {
          padding-left: 18px;
          width: 16px;
          height: 16px;
          background: url("../images/download.png") no-repeat;
          background-size: 16px 16px;
        }
      }
    }
    @media screen and (max-width:1200px){
      .subhead {
        display: block;
      }
    }
    /deep/ .el-table td:first-child {
      background: #f8faff;
      font-size: 15px;
    }
    /deep/ .el-table th {
      background: rgba(248, 250, 255, 1);
      color: rgba(144, 147, 153, 1);
      font-size: 15px;
      font-weight: 500;
    }
    /deep/ .el-table th:first-child {
      text-align: center;
      background: rgba(25, 137, 250, 1);
      font-size: 17px;
      font-weight: 500;
      color: #ffffff;
    }
    /deep/ .el-table .cell img {
      // width: 16px;
      height: 15px;
    }
  }
  .header-cursor{
    cursor: pointer;
  }
}
</style>
